import tenantTheme from '@theme';
import tenantRoutes from '@routes';
import tenantConstants from '@constants';
import tenantData from '@data';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Button, Flex, Image, Tag } from '../../../../components/common';
import { useRouteNavigate } from '../../../../hooks';
import { getClassifiedBaseURL } from '../../../../utility/env';
import { NavbarLinks } from './styled';
import { ProfolioLogoLite, ProfolioLogoLiteAr } from '../../../../components/svg';
import { addPropertyEvent } from '../../../../services/analyticsService';
import { getCurrentLocationPath } from '../../../../utility/utility';

const NavBarNavigationContainer = ({ locale, isMobile, fullWidth = false, hidePostAd = false }) => {
  const { t } = useTranslation();
  const pathLocale = locale == 'ar' ? '' : `/${locale}`;
  const user = useSelector((state) => state.app.loginUser.user);
  const navigate = useRouteNavigate();
  const location = useLocation();
  const navItems = useMemo(() => tenantData.getNavbarLinks?.(locale), [locale]);

  return isMobile ? (
    <Flex vertical>
      <a href={`${getClassifiedBaseURL()}/blog${pathLocale}`}>{t('Blog')}</a>
      <Link to={`${pathLocale}/companies`}>{t('Find an Agency')}</Link>
      <Link to={`${pathLocale}/new-projects`}>{t('New Projects')}</Link>
      {/* <Link to={`${pathLocale}/bayut-academy`}>{t('Bayut Academy')}</Link> */}
    </Flex>
  ) : (
    <div className={`navbar-floor ${fullWidth ? 'full-width' : ''}`}>
      <Flex className="container" align="center" justify="space-between" style={{ paddingBlock: '14px' }}>
        <Flex as="a" align="center" href={`${getClassifiedBaseURL()}${pathLocale}`}>
          {locale === 'en' ? (
            <ProfolioLogoLite
              horizontal={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.horizontal}
              text={tenantConstants?.APP_LOGO?.getLogoText(true)?.[locale]}
              width={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.width}
              height={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.height}
            />
          ) : (
            <ProfolioLogoLiteAr
              horizontal={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.horizontal}
              text={tenantConstants?.APP_LOGO?.getLogoText(true)?.[locale]}
              width={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.width}
              height={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.height}
            />
          )}
        </Flex>
        <NavbarLinks align="center" gap="22px">
          {!!navItems?.length &&
            navItems?.map((item, i) => (
              <a key={i} href={item.href}>
                {item.imgSrc && <Image src={item.imgSrc} style={{ ...item?.imgProps }} />}
                {t(item.title)}
                {item?.showNewTag && (
                  <Tag
                    color={tenantTheme['danger-color']}
                    style={{
                      '--tag-color': '#fff',
                      '--tag-font-size': '10px',
                      padding: '2px 8px',
                      borderRadius: '16px',
                      fontWeight: 400,
                      InsetBlockStart: '-4px',
                      insetInlineStart: '3px',
                    }}
                  >
                    {t('NEW')}
                  </Tag>
                )}
              </a>
            ))}

          {!hidePostAd && <Button
            type="success"
            icon="MdAddLocationAlt"
            onClick={() => {
              addPropertyEvent(user, getCurrentLocationPath(location), false);
              navigate(tenantRoutes.app('', false, user).post_listing.path);
            }}
          >
            {t('Post a Listing')}
          </Button>}
        </NavbarLinks>
      </Flex>
    </div>
  );
};

export default NavBarNavigationContainer;
